import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AvailableLeadsComponent } from './available-leads/available-leads.component';
import { AvailableSubscriptionsComponent } from './available-subscriptions/available-subscriptions.component';
import { UnPaidOrderComponent } from './un-paid-order/un-paid-order.component';
import { ClosedOrdersComponent } from './closed-orders/closed-orders.component';
import { UserPackagesSalesComponent } from './user-packages/user-packages.component';

const routes: Routes = [
  { path: 'available-leads', component: AvailableLeadsComponent },
  {
    path: 'available-subscriptions',
    component: AvailableSubscriptionsComponent,
  },
  { path: 'unpaid-orders', component: UnPaidOrderComponent },
  { path: 'closed-orders', component: ClosedOrdersComponent },
  { path: 'user-packages', component: UserPackagesSalesComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SalesRoutingModule {}
